module.exports = __webpack_public_path__ + "assets/dc658e3001ce58165fdc98714d6f7b52.json";